import store from './store'
import bugsnag from 'bugsnag-js'

const track = (event, properties = {}, options = {}, callback = () => {}) => {
  const Segment = window.analytics
  properties['event_name'] = event

  try {
    const state = store.getState()
    const trackData = {
      isPWM: true,
      prospectId: state.prospect && state.prospect.personID,
      ...properties,
    }

    Segment.track(event, trackData, options, callback)
  } catch (e) {
    bugsnag.notify('Analytics error: track attempted, Segment not found', event)
    callback()
  }
}

const page = (category = '', name = '', properties = {}, options = {}, callback = () => {}) => {
  const Segment = window.analytics

  try {
    Segment.page(category, name, properties, options, callback)
  } catch (e) {
    bugsnag.notify('Analytics error: page attempted, Segment not found')
    callback()
  }
}

export const trackAnalyticsEvent = eventName => track(eventName)

export default {
  track,
  page,
}



// WEBPACK FOOTER //
// ./src/analytics.js